(function($){
	$(document).ready(()=>{
		const $scrollBtn = $('.js-scrollup');

		if (window.innerWidth <= 1024) {
			const body = document.querySelector('body');

			$(window).scroll(()=>{
				if (window.pageYOffset > body.offsetHeight / 2) {
					if ($scrollBtn.css('opacity') == 0) {
						$scrollBtn.css({
							'visibility': 'visible',
							'opacity': 1,
						});
					}
				} else {
					if ($scrollBtn.css('opacity') == 1) {
						$scrollBtn.css({
							'visibility': 'hidden',
							'opacity': 0,
						});
					}
				}
			});
		}

		$('.scrollup, .scrollup__arrow').on('click', (e)=>{
			e.preventDefault();

			$('html, body').animate({
				scrollTop: 0,
			}, 1500);

			return false;
		});
	});
})(jQuery);
